<template>
  <div class="ad-pop" @click="goToAd" v-if="popShow">
    <img :src="liveRoomAdImg">
    <!-- <div @click.stop="close" class="close-handle">
      <svg-icon icon-class="close"></svg-icon>
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      popShow: true
    }
  },
  props: {
    liveRoomAdImg: {
      type: String,
      default: ''
    },
    liveRoomAdUrl: {
      type: String,
      default: ''
    }
  },
  methods: {
    goToAd() {
      if (this.liveRoomAdUrl) {
        const url = this.liveRoomAdUrl.indexOf('from=liveDetails') !== -1 
          ? this.liveRoomAdUrl 
          : this.liveRoomAdUrl.indexOf('?') !== -1 
          ? `${this.liveRoomAdUrl}&from=liveDetails` 
          : `${this.liveRoomAdUrl}?from=liveDetails`
        window.location.href = url
      }
    },
    close() {
      this.popShow = false
    }
  }
}
</script>

<style lang="scss" scoped>
.ad-pop {
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  img {
    width: 200px;
    max-height: 300px;
    // height: 200px;
    object-fit: cover;
  }
  .close-handle {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 40px;
    height: 40px;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    .svg-icon {
      width: 20px;
      height: 20px;
    }
  }
}
</style>
